














































import { ref, computed, defineComponent, onMounted, watch } from '@vue/composition-api';
import { SelectorsType, ChartDataCardRecordType } from '../types';

export default defineComponent({
    name: "module-title", // ICP备案主页面
    components: {

    },
    props: {
        isPagination: {
            type: Boolean,
            required: false,
            default: false
        },
        tableData: {
            type: Object,
            required: false,
            default: () => {return {}}
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        showIndex: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props, context) {
        const pageSize = 30;
        const paginationData = ref([]);
        onMounted(() => {
        });
        // 渲染的data
        const renderData = computed(() => {
            return props.isPagination ? paginationData.value : props.tableData && props.tableData.records || []
        })

        // 样式控制
        function displaySetting(configItem: SelectorsType) {
            return configItem.displaySetting && JSON.parse(configItem.displaySetting); // 可能存在undefined
        }

        function currentChange(size: number) {
            size = size - 1;
            const start = size * pageSize;
            const end = start + pageSize;
            paginationData.value = props.tableData.records.slice(start, end);
        }

        watch(
            () => props.tableData,
            async (val) => {
                if(props.isPagination) {
                    paginationData.value = val.records.slice(0, pageSize);
                }
            }
        );

        return {
            pageSize,
            renderData,
            displaySetting,
            currentChange
        }
    },
})
